import React from 'react';

const AccountSectionLayout = ({ children, classes }: { children: React.ReactNode; classes?: string }) => {
  return (
    <div className={`${classes}`}>
      {children}
    </div>
  );
};

export default AccountSectionLayout;
